<template>
  <div class="detail-container" style="">
    <a-alert :message="mdseInfo.mdseStatus|statusFormat" type="info" show-icon :description="mdseInfo.auditFailReason" 
    style="margin-bottom:16px"
    />

    
    <a-tabs type="card" v-model="tabKey" @change="callback" style="margin-top:16px" v-if="mdseInfo.mdseStatus==40">
        <a-tab-pane :key="1" tab="商品信息"/>
        <a-tab-pane :key="2" tab="授权信息"/>
    </a-tabs>
    
    <div class="price-box" v-show="tabKey==2">
      <div class="price-title">
        <span>渠道商</span>
      </div>
      <div class="price-header">
        <span>渠道商账号名</span>
        <span>渠道商手机号</span>
      </div>
      <div class="price-body" >
        <div v-for="item in business" style="border-bottom: 1px solid rgba(0,0,0,0.06);">
          <span>{{item.alias||'-'}}</span>
          <span>{{item.account||'-'}}</span>
        </div>
      </div>
    </div> 
    <div v-show="tabKey==1">
      <div class="product-container">
        <a-descriptions title="商品信息" >
          <a-descriptions-item label="商品名称" span="3">
            {{mdseInfo.mdseName}}  
          </a-descriptions-item>
          <a-descriptions-item label="大类">
            {{mdseInfo.primaryCategoryName||'-'}}
          </a-descriptions-item>
          <a-descriptions-item label="小类">
            {{mdseInfo.categoryNodeList|subcategoryF}}
          </a-descriptions-item>
          <a-descriptions-item label="提交时间">
            {{mdseInfo.createTime||'-'}}
          </a-descriptions-item>
          <a-descriptions-item label="品牌" span='3'>
            {{mdseInfo.brand||'-'}}
          </a-descriptions-item>
          <a-descriptions-item label="供应商账号名">
            {{mdseInfo.supplierAlias||'-'}}
          </a-descriptions-item>
          <a-descriptions-item label="供应商手机号">
            {{mdseInfo.supplierAccount||'-'}}
          </a-descriptions-item>
          <a-descriptions-item label="提交人">
            {{mdseInfo.supplierAccount||'-'}}
          </a-descriptions-item>
          <a-descriptions-item label="商品主图">
            <div class="img-main">
              <div class="img-item" v-for="(item,index) in mdseInfo.mdseImgPathList" :key="index">
                <img :src="item" ></img>
              </div>
            </div>
          </a-descriptions-item>
        </a-descriptions>
      </div>
      <div class="spec-container">
        <span class="ant-descriptions-title">规格信息</span>
        <div class="explicit-container">
          <span class="spec-label">规格明细：</span>
          <a-table :data-source="dataSku" rowKey="variantId" :pagination="false"  bordered >
              <template slot="title" slot-scope="currentPageData">
              <span>价格规则：</span> 
              {{includedTax}}
              </template>
              <a-table-column  v-for="(item,i) in specNameList" :key="'info2-'+i" :title="item" :data-index="item" />
              <a-table-column  title="商品链接价"  data-index="itemPrice" >
                <span slot-scope="itemPrice">{{itemPrice|toFixed2}}</span>
              </a-table-column    >
              <a-table-column    data-index="supplyPrice" >
                <div slot="title">进货价(元)
                    <a-tooltip placement="bottom"
                    :getPopupContainer="
                    triggerNode => {
                      return triggerNode.parentNode || document.body;
                    }">
                  <span slot="title">从供应商进货的价格</span>
                  <a-icon type="exclamation-circle" />
                </a-tooltip>
                </div>
                <span slot-scope="supplyPrice">{{supplyPrice|toFixed2}}</span>
              </a-table-column    >
              <a-table-column  title="库存"    data-index="stockNum" ></a-table-column    >
              <a-table-column  title="商品链接"data-index="itemUrl" :ellipsis="true"  >
                <div slot-scope="itemUrl" :title="itemUrl" style="max-width:250px;overflow:hidden;text-overflow: ellipsis;white-space: nowrap">{{itemUrl}}</div>
              </a-table-column    >
              <a-table-column  title="状态"    data-index="variantStatus" >
                <div slot-scope="variantStatus">{{variantStatus|statusDFormat}}</div>
              </a-table-column    >
              <a-table-column  title="操作"   data-index="variantId">
                <div slot-scope="variantId,text">
                  <span v-if="text.variantStatus!=20" @click="linkTo(variantId)" class="link">查看详情</span>
                  <span v-else>--</span>
                </div>
              </a-table-column    >
          </a-table>
        </div>
        <div class="img-container">
            <label class="table-name spec-label">规格图片：</label>
            <div class="table-body">
                <a-table :columns="columns" :data-source="dataImg" bordered :pagination="false" rowKey="variantId">
                    <span slot="skuImgTitle" class="skuImg-header">
                        <span class="first-line">SKU图</span>
                        <span class="sec-line">800*800像素</span>
                    </span>
                    <span slot="detailImgTitle" class="detail-header">
                        <span class="first-line">详情页</span>
                        <span class="sec-line">750像素宽度，按上传顺序展示</span>
                    </span>
                    <div slot="skuImg" slot-scope="text">
                      <img :src="text" alt="">
                    </div>
                    <div slot="detailImg" slot-scope="detailImg">
                      <div>
                          <img :src="item" alt="" v-for="item in detailImg">
                      </div>
                    </div>
                </a-table>
            </div>
        </div>
        <div class="params-container">
          <span class="spec-label">规格参数：</span>
          <div class="box-header">
            <a-radio-group v-model="radioParams">
                <a-radio-button :value="index2" v-for="(item,index2) in specValues" :key="index2" style="margin-right:8px">
                  <span :title="item">{{item|max16}}</span>
                </a-radio-button>
            </a-radio-group>
          </div>
          <div class="box-body">
            <a-descriptions  >
              <a-descriptions-item :label="item.name" v-for="(item, index1) in dataParam[radioParams]" :key="index1">
                {{item.value||'-'}}  
              </a-descriptions-item>
            </a-descriptions>
          </div>
        </div>
      </div>
    </div>
    <div class="btn-container" v-show="mdseInfo.mdseStatus!=20">
      <div v-show="mdseInfo.mdseStatus==10">
        <a-button type="primary" @click="openModal(1)" style="margin-right:16px">审核通过</a-button>
        <a-button @click="openModal(2)">审核不通过</a-button>
      </div>
      <div v-show="mdseInfo.mdseStatus==30||mdseInfo.mdseStatus==40">
        <a-button type="primary" @click="openModal(3)" style="margin-right:16px">授权渠道商</a-button>
      </div>
    </div>
    <transfer ref="transfer" @getdata="getdata"/>
    <m-Modal ref="mModal" :mdseIds="mdseInfo.mdseId" @getdata="getdata"/>
  </div>
</template>

<script>
import mModal from "./components/mModal"
import transfer from "./components/transfer"
import { getMdseDetails,batchAudit,getLicDistributors } from "@/api/product";
const columns = [
  {
    title: "规格",
    dataIndex: "name",
    ellipsis: true,
    width: "160px"
  },
  {
    dataIndex: "skuImg",
    scopedSlots: "skuImg",
    slots: { title: "skuImgTitle" },
    scopedSlots: { customRender: "skuImg" },
    width: "128px"
  },
  {
    slots: { title: "detailImgTitle" },
    dataIndex: "detailImg",
    scopedSlots: { customRender: "detailImg" }
  }
];
export default {
  name: "pmsd",
  components:{mModal,transfer},
  data() {
    return {
      includedTax:'',
      tabKey:1,
      radioParams:0,
      specValues:[],
      specNameList: [],
      dataSku: [],
      dataImg: [],
      dataParam: [],
      columns,
      business: [],
      mdseInfo: {},
      variantInfo: {},
    };
  },
  created() {
    this.getdata();
    getMdseDetails
  },
  filters: {
    statusDFormat(value) {
      switch (value) {
        case 10:
          return "待审核";
          break;
        case 20:
          return "审核不通过";
          break;
        case 30:
          return "审核通过";
          break;
        case 40:
          return "预警商品";
          break;
        case 50:
          return "已下架";
          break;
      }
    },
    statusFormat(value) {
      switch (value) {
        case 10:
          return "待审核";
          break;
        case 20:
          return "审核不通过";
          break;
        case 30:
          return "审核通过待授权";
          break;
        case 40:
          return "已授权";
          break;
      }
    },
    max16(value) {
      if (value.length > 16) {
        return value.substring(0, 15) + "...";
      }
      return value;
    },
    subcategoryF(value) {
      if (!(value instanceof Array)) {
        return "--";
      }
      let label = "";
      value.forEach(item => {
        label += item.name + "、";
      });
      return label.substr(0, label.length - 1);
    },
  },
  methods: {
    callback(key) {
      key==2&&this.getChannelBusiness();
    },
    //跳转规格详情
    linkTo(id) {
      let newpage = this.$router.resolve({
        name: "spec-detail",
        query: { id }
      });
      window.open(newpage.href);
    },
    getdata() {
      let params = {
        mdseId: this.$route.query.id
      };
      getMdseDetails(params).then(res => {
        this.mdseInfo = {...res.data.mdseInfo};
        const variantInfoList = res.data.variantInfoList;
        this.specNameList = this.mdseInfo.variantCombineObject.headers; //动态规格名
        let specValues = []//规格值
        let dataSku = []; //规格明细
        let dataImg = []; //规格图片
        let dataParam = []; //规格参数
        this.includedTax = variantInfoList[0].supplyPriceType==1?'含税含运费':'含税（运费单独结算）';
        variantInfoList.forEach(element => {
          let skuItem = {};
          skuItem.supplyPrice = element.supplyPrice;
          skuItem.stockNum = element.stockNum;
          skuItem.itemUrl = element.itemUrl;
          skuItem.variantStatus = element.variantStatus;
          skuItem.variantId = element.variantId;
          skuItem.itemPrice = element.itemPrice;
          let specValue = "";
          element.variantNameObject.values.forEach((item,index) => {
            skuItem[this.specNameList[index]] = item;
            specValue += item + ",";
          });
          specValue=specValue.slice(0,specValue.length-1)
          dataSku.push(skuItem);
          specValues.push(specValue);
          dataParam.push(element.variantParamObjectList);
          dataImg.push({
            variantId: element.variantId,
            name: specValue,
            skuImg: element.skuImgPath,
            detailImg: element.detailImgPathList
          });
        });
        this.specValues = specValues;
        this.dataSku = dataSku;
        this.dataImg = dataImg;
        this.dataParam = dataParam;
      });
    },
    getChannelBusiness() {
      getLicDistributors({mdseId:this.$route.query.id}).then(res => {
        this.business = res.rows;
      });
    },
    audit() {
      let params = {
        auditFailReason: "",
        mdseIds: [this.$route.query.id],
        mdseStatus: 30
      }
      batchAudit(params).then(res => {
          if (res.result) {
            this.$message.success('操作成功');
            this.getdata();
          }else{
            this.$message.warning(res.message)
          }
        });
    },
    changeActive($event) {
      $event.currentTarget.className = "active";
    },
    openModal(index, params) {
      if (index == 1) {
        this.audit()
      } else if (index == 2) {
        this.$refs.mModal.showModal()
      } else if(index==3){
        this.$refs.transfer.showModal([this.$route.query.id])
      }
    }
  }
};
</script>

<style lang="less" scoped>
/deep/.ant-tabs-bar {
    margin-bottom:0;
}
.detail-container {
  position: relative;
  min-height: 100%;
  padding-bottom: 75px;
	box-sizing: border-box;
  margin: 0 24px;
  img {
    width: 104px;
    height: 104px;
    background: rgba(255, 255, 255, 1);
    border-radius: 2px;
    margin-right: 12px;
  }
  .spec-container {
    margin-top: 16px;
    padding: 20px 24px;
    background: rgba(255, 255, 255, 1);
    border-radius: 2px;
    .spec-label {
      display: inline-block;
      margin-top: 12px;
    }
    .img-container {
      /deep/.ant-table-bordered .ant-table-thead > tr > th {
        border-right: 0;
      }
      /deep/.ant-table-tbody
        > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)
        > td {
        background: #fff;
      }
      .skuImg-header,
      .detail-header {
        span {
          display: block;
        }
        .first-line {
          height: 22px;
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: rgba(0, 0, 0, 0.85);
          line-height: 22px;
        }
        .sec-line {
          height: 20px;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.45);
          line-height: 20px;
        }
      }
    }
    .params-container{
      .box-header{
        padding: 12px;
        // border-radius:2px;
        border:1px solid rgba(0,0,0,0.15);
        /deep/label.ant-radio-button-wrapper.ant-radio-button-wrapper-checked {
            border: 2px solid rgba(2,84,211,1);
            box-shadow:none;
            border-radius:2px;
        }
        .ant-radio-button-wrapper {
          border-radius:2px;
          font-size:14px;
          font-family:PingFangSC-Regular,PingFang SC;
          font-weight:400;
          color:rgba(0,0,0,0.65);
          background:rgba(0,0,0,0.04);
          border-radius:2px;
          border:1px solid rgba(0,0,0,0.15);
        }
      }

    }
    .explicit-container {
      .link {
        cursor: pointer;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(2, 84, 211, 1);
        line-height: 22px;
      }
      /deep/.ant-table-title {
        background: #fafafa;
      }
      /deep/.ant-table-bordered .ant-table-body > table {
        border-top: 0;
      }
      /deep/.ant-table-bordered .ant-table-thead > tr > th {
        border-right: 0;
      }
      /deep/.ant-table-thead > tr > th {
        .ant-table-selection {
          display: none;
        }
      }
    }
  }
  .product-container {
    /deep/.ant-descriptions-row:last-child {
      .ant-descriptions-item-label {
        vertical-align: top;
      }
      .img-main {
        display: flex;
        .img-item {
          margin-right: 12px;
          background: rgba(255, 255, 255, 1);
          border-radius: 2px;
          img {
            width: 104px;
            height: 104px;
          }
        }
      }
    }
  }
}

/deep/.ant-tooltip-inner {
  span {
    padding: 0px !important;
  }
}
.ant-descriptions {
  border-radius: 2px;
  // margin-top: 16px;
  background-color: #ffffff;
  padding: 20px 24px;
}
/deep/ .ant-popover-inner-content {
  min-width: 216px;
  height: 64px;
  padding: 16px 12px;
}
.price-box {
  border-radius: 2px;
  background-color: #ffffff;
  padding: 20px 24px;
  .link-box {
    padding: 16px 0;
    .ant-btn-primary {
      margin: 0 16px;
    }
  }
  .price-header {
    font-weight: 500;
    background-color: rgba(250, 250, 250, 1);
    border-bottom: 1px solid #e8e8e8;
  }
  .price-header,
  .price-body {
    position: relative;
    span {
      padding: 16px 24px;
      display: inline-block;
      width: calc((90%-48px) / 3);
    }
  }
}

.btn-container {
	position: absolute;
	bottom: 0;
	width: calc(100%) ;
	box-shadow:0px 9px 28px 8px rgba(0,0,0,0.05),0px 6px 16px 0px rgba(0,0,0,0.08),0px 3px 6px -4px rgba(0,0,0,0.12);
  border-radius:2px;
  border-bottom: none;
  background: rgba(255, 255, 255, 1);
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>